import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState } from 'react'
import styles from './DocumentView.module.scss'
import { addAttachment, deleteAttachment } from '../../../../service/DocflowService'

function fmtSize(bytes) {
  if (!bytes) return ''
  if (bytes < 1024) return tr("{{value0}} Б", { value0: bytes })
  if (bytes < 1024 * 1024) return tr("{{value0}} КБ", { value0: (bytes / 1024).toFixed(0) })
  return tr("{{value0}} МБ", { value0: (bytes / 1024 / 1024).toFixed(1) })
}

const FILE_ICONS = {
  pdf: '📕', doc: '📘', docx: '📘', xls: '📗', xlsx: '📗',
  ppt: '📙', pptx: '📙', jpg: '🖼️', jpeg: '🖼️', png: '🖼️',
  zip: '🗜️', rar: '🗜️', txt: '📃',
}

export default function AttachmentsList({ docId, attachments: init = [], isCreator }) {
  useInterfaceLanguage();
  const [attachments, setAttachments] = useState(init)
  const [previewUrl, setPreviewUrl]   = useState(null)
  const [previewExt, setPreviewExt]   = useState('')
  const [uploading, setUploading]     = useState(false)

  async function handleUpload(e) {
    const file = e.target.files[0]
    if (!file) return
    const fd = new FormData()
    fd.append('file', file)
    setUploading(true)
    try {
      const r = await addAttachment(docId, fd)
      setAttachments(prev => [...prev, r.data])
    } finally { setUploading(false) }
  }

  async function handleDelete(id) {
    await deleteAttachment(id)
    setAttachments(prev => prev.filter(a => a.id !== id))
  }

  return (
    <div className={styles.attachmentsSection}>
      <h3 className={styles.panelSectionTitle}>{tr("Вложения")}{tr(attachments.length > 0 && (
          <span className={styles.commentCount}>{tr(attachments.length)}</span>
        ))}
      </h3>

      {tr(attachments.length === 0 && <p className={styles.emptySub}>{tr("Вложений нет")}</p>)}

      <div className={styles.attachList2}>
        {attachments.map(a => {
          const ext  = (a.file_extension || '').toLowerCase()
          const icon = FILE_ICONS[ext] || '📎'
          const canPreview = ['pdf', 'jpg', 'jpeg', 'png'].includes(ext)

          return (
            <div key={a.id} className={styles.attachItem2}>
              <span className={styles.attachIcon2}>{icon}</span>
              <div className={styles.attachInfo}>
                <span className={styles.attachName2}>{tr(a.file_name)}</span>
                <span className={styles.attachSize2}>{fmtSize(a.file_size)}</span>
              </div>
              <div className={styles.attachItemActions}>
                {tr(canPreview && (
                  <button
                    className={styles.attachActionBtn}
                    title={tr("Просмотр")}
                    onClick={() => { setPreviewUrl(a.file_url); setPreviewExt(ext) }}
                  >
                    👁
                  </button>
                ))}
                <a
                  className={styles.attachActionBtn}
                  href={a.file_url}
                  target="_blank"
                  rel="noreferrer"
                  title={tr("Скачать")}
                >
                  ⬇
                </a>
                {tr(isCreator && (
                  <button
                    className={`${styles.attachActionBtn} ${styles.attachDeleteBtn}`}
                    onClick={() => handleDelete(a.id)}
                    title={tr("Удалить")}
                  >
                    ×
                  </button>
                ))}
              </div>
            </div>
          )
        })}
      </div>

      {tr(isCreator && (
        <label className={styles.addAttachBtn}>
          {uploading ? tr("Загрузка…") : tr("+ Добавить вложение")}
          <input type="file" hidden disabled={uploading} onChange={handleUpload} />
        </label>
      ))}

      {/* Preview modal */}
      {tr(previewUrl && (
        <div className={styles.previewOverlay} onClick={() => setPreviewUrl(null)}>
          <div className={styles.previewBox} onClick={e => e.stopPropagation()}>
            <button className={styles.previewClose} onClick={() => setPreviewUrl(null)}>×</button>
            {previewExt === 'pdf' ? (
              <iframe src={previewUrl} className={styles.previewIframe} title={tr("Предпросмотр документа")} />
            ) : (
              <img src={previewUrl} alt={tr("Предпросмотр документа")} className={styles.previewImg} />
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
